/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_SqmInputs */

const en_admin_resource_form_sqm = /** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqm`)
};

const de_admin_resource_form_sqm = /** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qm`)
};

const es_admin_resource_form_sqm = /** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const fr_admin_resource_form_sqm = /** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const nl_admin_resource_form_sqm = /** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

/** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */
const it_admin_resource_form_sqm = en_admin_resource_form_sqm;

/** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */
const pt_br2_admin_resource_form_sqm = en_admin_resource_form_sqm;

/** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */
const pl_admin_resource_form_sqm = en_admin_resource_form_sqm;

/** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */
const hu_admin_resource_form_sqm = en_admin_resource_form_sqm;

/** @type {(inputs: Admin_Resource_Form_SqmInputs) => LocalizedString} */
const ro_admin_resource_form_sqm = en_admin_resource_form_sqm;

/**
* | output |
* | --- |
* | "sqm" |
*
* @param {Admin_Resource_Form_SqmInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_sqm = /** @type {((inputs?: Admin_Resource_Form_SqmInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_SqmInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_sqm(inputs)
	if (locale === "de") return de_admin_resource_form_sqm(inputs)
	if (locale === "es") return es_admin_resource_form_sqm(inputs)
	if (locale === "fr") return fr_admin_resource_form_sqm(inputs)
	if (locale === "nl") return nl_admin_resource_form_sqm(inputs)
	if (locale === "it") return it_admin_resource_form_sqm(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_sqm(inputs)
	if (locale === "pl") return pl_admin_resource_form_sqm(inputs)
	if (locale === "hu") return hu_admin_resource_form_sqm(inputs)
	return ro_admin_resource_form_sqm(inputs)
});
export { admin_resource_form_sqm as "admin.resource_form.sqm" }